import { createPDFDocument } from "../pdf_create";
import { createHeader } from "./createHeader";
import { createTable } from "./createTable";
import { createSupplyPdfPageProperties } from "./pageProperties";

export async function createSupplyPDFDocument(supplyForm, deliveryDate, supplyDivisionId, supplier, printSetting) {

  const pdfDoc = await createPDFDocument()  
  const pageProperties = await createSupplyPdfPageProperties(pdfDoc, printSetting);

  const suppliesPartedByPage = formatSuppliesOnPages(supplyForm, deliveryDate, supplyDivisionId, supplier, pageProperties.rowNumber);

  // ページの生成
  suppliesPartedByPage.forEach((suppliesOnPage) => {   
    createSupplyPage(pdfDoc, suppliesOnPage, pageProperties);
  });


  pdfDoc.setCreator("丸伊伊那青果　事務担当");

  // Serialize the PDFDocument to bytes (a Uint8Array)
  return await pdfDoc.save();
}

const createSupplyPage = (pdfDoc, supplyOnPage, pageProperties) => {
  const page = pdfDoc.addPage([pageProperties.width, pageProperties.height]);
  createHeader(page, supplyOnPage, pageProperties);
  createTable(page, supplyOnPage.details, pageProperties);
}

const formatSuppliesOnPages = (supplyDetails, deliveryDate, supplyDivisionId, supplier, rowNumber) => {

  const result = [];
  let currentSuppliesOnPage = [];
  let currentPageNum = 1;

  supplyDetails.forEach((supplyDetail) => {
    
    const supplies = supplyDetail.supplyQuantityDetails
                      .filter((detail) => 
                          Boolean(detail.supplyQuantity)
                          && !detail.isDelete
                      )
                      .map((detail) => ({...supplyDetail, ...detail}));

    if (currentSuppliesOnPage.length + supplies.length > rowNumber) {
      result.push({
        deliveryDate,
        supplierName: supplier.commodityOwnerName,
        supplyDivisionId,
        pageNumber: currentPageNum,
        details: currentSuppliesOnPage
      });

      currentPageNum += 1;
      currentSuppliesOnPage = supplies;
    } else {
      supplies.forEach((supply) => {
        currentSuppliesOnPage.push(supply)
      })
    }
  });

  if (currentSuppliesOnPage.length > 0) {                 
    result.push({
      deliveryDate,
      supplierName: supplier.commodityOwnerName,
      supplyDivisionId,
      pageNumber: currentPageNum,
      details: currentSuppliesOnPage
    });
  }

  return result;
}


